import APIUser from '@/xhr/xhr-user'

const namespaced = true

const initialState = {
  mail: null,
  code_request_id: null,
  authentication_code: null,
  form: {},
  user: {}
}
export const state = { ...initialState }

const getters = {
  mail: state => state.mail,
  code_request_id: state => state.code_request_id,
  authentication_code: state => state.authentication_code,
  form: state => state.form,
  user: state => state.user
}

const mutations = {
  setMail (state, mail) {
    state.mail = mail
  },
  setCodeRequestId (state, id) {
    state.code_request_id = id
  },
  setAuthenticationCode (state, code) {
    state.authentication_code = code
  },
  setForm (state, data) {
    state.form = data
  },
  setUser (state, data) {
    state.user = data
  },
  clear (state) {
    state.mail = null
    state.code_request_id = null
    state.authentication_code = null
    state.form = {}
    state.user = {}
  }
}

const actions = {
  // 本人確認依頼（会員登録）
  sendRegisterMail ({commit}, params) {
    return new Promise((resolve, reject) => {
      APIUser.registerMail({
        mail: params.mail
      }).then(_res => {
        commit('setMail', params.mail)
        commit('setCodeRequestId', _res.data.code_request_id)
        resolve(_res.data)
      }).catch(err => {
        reject(err.response)
      })
    })
  },

  // 本人確認（会員登録）
  checkRegisterCode ({commit}, params) {
    return new Promise((resolve, reject) => {
      APIUser.registerCode({
        id: params.id,
        authentication_code: params.authentication_code
      }).then((_res) => {
        commit('setAuthenticationCode', params.authentication_code)
        resolve(_res.data)
      }).catch(function (err) {
        reject(err.response)
      })
    })
  },

  // 会員登録
  registerUser ({state, commit}) {
    return new Promise((resolve, reject) => {
      APIUser.registerUser({
        code_request_id: state.code_request_id,
        surname: state.form.surname,
        first_name: state.form.first_name,
        surname_kana: state.form.surname_kana,
        first_name_kana: state.form.first_name_kana,
        tel: state.form.tel,
        post_code: state.form.post_code,
        prefecture_id: state.form.prefecture_id,
        city_name: state.form.city_name,
        address: state.form.address,
        birthday: state.form.birthday,
        login_password: state.form.login_password,
        login_password_confirmation: state.form.login_password_confirmation
      }).then((_res) => {
        commit('setUser', _res.data)
        resolve(_res.data)
      }).catch(function (err) {
        reject(err.response)
      })
    })
  }
}

// モジュールに登録されるオブジェクト
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accountCreate.js